module.exports = __webpack_public_path__ + "img/road.1e73a621.svg";